import { Component, EventEmitter, Input, Output } from "@angular/core";
import { LatestLearningSection } from "../../../_models/student-bookings/latest-learning-section";


@Component({
    selector: 'latest-learning-section',
    templateUrl: 'latest-learning-section.component.html',
    styleUrls: ['latest-learning-section.component.css'],
    standalone: false
})
export class LatestLearningSectionComponent {
  @Input() public studentId: number = 0;
  @Input() public learningSection: LatestLearningSection;
  @Output() addLearningSectionClicked = new EventEmitter<boolean>();
  @Output() viewTimelineClicked = new EventEmitter<boolean>();

  constructor() {

  }

  public lastAssessmentScoreExists(): boolean{
    return this.learningSection.lastAssessmentScore !== 'no assessment score completed';
  }

  public lastTargetExists(): boolean {
    return this.learningSection.lastTarget !== 'no target completed';
  }

  public lastProgressExists(): boolean {
    return this.learningSection.lastProgress !== 'no progress completed';
  }

  public viewTimeline(): void {
    this.viewTimelineClicked.emit(true);
  }

  public addLearningSection() {
    this.addLearningSectionClicked.emit(true);
  }

}
